import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClusterService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    try {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    } catch (e) { }
  }

  ClusterMasterLoad(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ClusterMasterLoad/Load`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ClusterMasterInsert(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ClusterMasterInsert/Update`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

}
